
.modalHeader {
  display: flex;
  padding: 2.5rem 0 1.5rem 0;
  justify-content: center;
  align-items: center;
}

.modalBody {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  align-self: stretch;
}
